import React, { useEffect, useState } from "react";
import firebase from "./../../firebase";

import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";

import * as authActions from "../../store/actions/authActions";
import PreloaderInner from "./../../components/preloader/loader";

// Stylesheet
import "./TransactionTable.css";

// Assets
import priceEth from "../../assets/eth.svg";
import pricePoly from "../../assets/matic.svg";

import { authFeatureKey, nftFeatureKey } from "../../store/featureKeys";
import { color } from "@mui/system";
import { DataGrid } from '@mui/x-data-grid';
import timeago from 'epoch-timeago';


function TransactionTable({ nftid, refreshToken }) {
  const [transactions, setTransactions] = useState([]);
  const limit = 5;
  useEffect(async () => {
    let txns = [];
    if (nftid) {
        await firebase
        .firestore()
        .collection("NFTTransactionHistory")
        .limit(limit)
        .where("nftid", "==", nftid)
        .orderBy("createdAt", "desc")
        .get()
        .then((querySnapshot) => {
            if (querySnapshot.empty) {
            return;
            } else {
            querySnapshot.forEach((doc) => {
                var document = {};
                document.id = doc.data().txnHash;
                document.chain = doc.data().chain;
                document.txnType = doc.data().txnType;
                document.price = doc.data().price;
                document.from = doc.data().from;
                document.to = doc.data().to;
                document.createdAt = timeago(doc.data().createdAt.toDate());
                // Change this to etherscan mainnet based on polygon or eth
                var scanurl = document.chain == "Ethereum" ? "https://rinkeby.etherscan.io/tx/" : "https://mumbai.polygonscan.com/tx/";
                document.txnHashUrl = scanurl + doc.data().txnHash;
                txns.push(document);
            });
            }
        })
        .catch((error) => {
            console.log("TXN Error", error);
        });
        setTransactions(txns);
    }
  }, [nftid, refreshToken]);

  const columns = [
    { field: 'txnType', headerName: 'Event', width: 100 },
    { field: 'price', headerName: 'Price', width: 100 },
    { field: 'from', headerName: 'From', width: 400 },
    { field: 'to', headerName: 'To', width: 400 },
    { field: 'createdAt', headerName: 'Date', width: 240},
    { field: 'txnHashUrl', headerName: 'Txn Hash', width: 100, 
      renderCell: (params) => (
        <div>
          <a href={params.value} style={{textDecoration: "none", borderBottom: "1px solid #d3aa4b"}} target="_blank" > TXN </a>
        </div>
      )
    }
  ];

  return (
    <div style={{height: 400, maxHeight: 400}}>
      <p style={{marginTop: "100px", fontSize: "28px"}}>NFT Activity</p>
      <DataGrid
        rows={transactions}
        columns={columns}
        pageSize={limit}
        rowsPerPageOptions={[limit]}
      />
    </div>
  );
}

export default TransactionTable;